import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-termos-condicoes-pi',
  templateUrl: './termos-condicoes-pi.component.html',
  styleUrls: ['./termos-condicoes-pi.component.scss']
})
export class TermosCondicoesPIComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    
  }

}
